import React from 'react';
import {
  Snackbar,
  Alert,
  AlertColor
} from '@mui/material';

interface ToastProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({
  open,
  message,
  severity = 'success',
  onClose,
  duration = 4000
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          borderRadius: 2,
          fontWeight: 500
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
